import {Avatar} from '@/components/ui/avatar/Avatar'
import {FC, ReactNode} from 'react'
import {StyledAvatarGroupItem} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

interface AvatarGroupProps {
    children?: ReactNode
    max?: number
    className?: string
}

interface AvatarGroupItemProps {
    name: string
    imageUrl?: string
    size?: 'xs' | 'sm' | 'md' | 'lg'
}

const AvatarGroupItem: FC<AvatarGroupItemProps> = ({name, imageUrl, size = 'xs'}) => {
    return (
        <StyledAvatarGroupItem>
            <Avatar name={name} imageUrl={imageUrl} size={size} />
        </StyledAvatarGroupItem>
    )
}

const AvatarGroupRoot: FC<AvatarGroupProps> = ({children, className}) => {
    return (
        <Flexbox className={className} align="center" gap={1.25}>
            {children}
        </Flexbox>
    )
}

export const AvatarGroup = Object.assign(AvatarGroupRoot, {
    Item: AvatarGroupItem
})
